















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ClinicResponse, MedicalTreatmentSpot } from '@/interface/api'
import dayjs from '@/plugins/dayjs'
import Constants from '@/utils/constants'
import { formatDate } from '@/utils/index'
import { ReservationFormViewModel } from '@/models/ReservationFormViewModel'
@Component({
  name: 'ReservationCalendar'
})
export default class ReservationCalendar extends Vue {
  @Prop({ default: () => null }) reservationForm!: ReservationFormViewModel

  @Prop({ default: () => [] }) private publicHolidyList!: string[]
  @Prop({ default: () => [] })
  private medicalTreatmentSpots!: MedicalTreatmentSpot[]

  private startDate = new Date()
  private loading = false
  private weeksLater = 0

  private get endDate(): Date {
    return new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate() + 6
    )
  }

  private get formatedStartDate(): string {
    return formatDate(
      this.startDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI
    )
  }

  private get formatedEndDate(): string {
    return formatDate(this.endDate, Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI)
  }

  private prev() {
    this.weeksLater--
    this.startDate = new Date(
      this.startDate.setDate(this.startDate.getDate() - 7)
    )
  }

  private next() {
    this.weeksLater++
    this.startDate = new Date(
      this.startDate.setDate(this.startDate.getDate() + 7)
    )
  }

  private today() {
    this.weeksLater = 0
    this.startDate = new Date()
  }

  @Watch('startDate')
  public async onStartDateChange(): Promise<void> {
    this.$emit('on-start-date-change', this.startDate)
  }

  private get targetDates(): { label: string; date: string }[] {
    const dates = this.medicalTreatmentSpots.map(treatmentSpot => {
      return {
        label:
          formatDate(new Date(treatmentSpot.day), Constants.DateFormat.D) +
          '\n' +
          formatDate(new Date(treatmentSpot.day), Constants.DateFormat.dd),
        date: treatmentSpot.day
      }
    })
    return dates
  }

  private get treatmentSpotTimes(): string[] {
    const times: string[] = []
    const startTimes = this.reservationForm.clinic.business_hours.map(
      businessHours => {
        const time = businessHours.open_time.split(':')
        const date = new Date(1970, 0, 1, Number(time[0]), Number(time[1]))
        return dayjs(date)
      }
    )
    const minStartTime = dayjs.min(startTimes)
    const endTimes = this.reservationForm.clinic.business_hours.map(
      businessHours => {
        const time = businessHours.close_time.split(':')
        const date = new Date(1970, 0, 1, Number(time[0]), Number(time[1]))
        return dayjs(date)
      }
    )
    const maxEndTime = dayjs.max(endTimes)
    const intervalCount = maxEndTime.diff(minStartTime, 'minute') / 30
    times.push(minStartTime.format(Constants.DateFormat.HH_mm))
    for (let i = 1; i < intervalCount; i++)
      times.push(
        minStartTime
          .clone()
          .add(i * 30, 'm')
          .format(Constants.DateFormat.HH_mm)
      )
    times.push(maxEndTime.format(Constants.DateFormat.HH_mm))
    return times
  }

  private isAvailableSpot(date: string, spotTime: string): boolean {
    if (
      this.reservationForm.clinic.holiday_flag &&
      this.publicHolidyList.includes(
        formatDate(new Date(date), Constants.DateFormat.YYYY_MM_DD_HYPHEN)
      )
    )
      return false
    const targetMedicalTreatmentSpot = this.medicalTreatmentSpots.find(
      medicalTreatmentSpot => medicalTreatmentSpot.day === date
    )
    const targetSpot = targetMedicalTreatmentSpot!.spots.find(
      spot =>
        formatDate(new Date(spot.spot_datetime), Constants.DateFormat.HH_mm) ===
        spotTime
    )
    if (!targetSpot) return false
    return true
  }

  private selectTreatmentSpot(date: string, spotTime: string) {
    const targetMedicalTreatmentSpot = this.medicalTreatmentSpots.find(
      medicalTreatmentSpot => medicalTreatmentSpot.day === date
    )
    const targetSpot = targetMedicalTreatmentSpot!.spots.find(
      spot =>
        formatDate(new Date(spot.spot_datetime), Constants.DateFormat.HH_mm) ===
        spotTime
    )
    this.$emit(
      'on-treatment-spot-select',
      targetSpot!.id,
      targetSpot!.spot_datetime
    )
  }
}
